/** @jsxImportSource @gasman/smush */

import './main.css';

import { ContainerComponent } from '@gasman/smush';

import { Menu } from '../panels/menu';
import { Toolbar } from '../panels/toolbar';
import { PatternEditor } from '../panels/pattern_editor';
import { PositionEditor } from '../panels/position_editor';
import { SongControls } from '../panels/song_controls';

import { PatternEditorState } from './pattern_editor_state';

class MainView extends ContainerComponent {
    constructor(app, engine) {
        super();

        this.song = null;
        this.toolbar = new Toolbar(app);
        this.menu = new Menu(app);
        this.positionEditor = new PositionEditor(app, this, engine.Song);
        this.patternEditor = new PatternEditor(app, engine);
        this.songControls = new SongControls(app, engine);

        this.components = [
            this.menu,
            this.positionEditor,
            this.patternEditor,
            this.songControls,
        ];
    }

    render(container) {
        this.toolbar.render(container);
        this.menu.render(container);
        container.appendChild(
            <div class="song-workspace">
                {this.songControls}
                {this.positionEditor}
            </div>,
        );
        this.patternEditor.render(container);
    }

    bind(song, opts) {
        this.song = song;
        this.state = new PatternEditorState();
        this.toolbar.bind(song, opts);
        this.menu.bind(song, opts);
        this.songControls.bind(song, opts);
        this.positionEditor.bind(song, opts);
        this.patternEditor.bindSong(song, opts);
        this.patternEditor.bindState(this.state);
    }

    unbind() {
        this.toolbar.unbind();
        this.menu.unbind();
        this.songControls.unbind();
        this.positionEditor.unbind();
        this.patternEditor.unbindState();
        this.patternEditor.unbindSong();
    }

    keydown = (event) => {
        if (this.song) {
            if ((event.ctrlKey || event.metaKey) && event.key === 'z') {
                this.song.undo();
            } else if ((event.ctrlKey || event.metaKey) && event.key === 'y') {
                this.song.redo();
            }
        }
    };
    show() {
        super.show();
        document.addEventListener('keydown', this.keydown);
    }
    hide() {
        document.removeEventListener('keydown', this.keydown);
        super.hide();
    }
}

export { MainView };
